import { remoteRequest } from './httpClient'

function normalizeParameter(body) {
  const payload = {
    global_parameter: String(body.global_parameter || body.globalParameter || '').trim(),
    value: String(body.value ?? ''),
    updatedUser: body.updatedUser || body.updated_user || 'admin_v2',
    updated_user: body.updatedUser || body.updated_user || 'admin_v2',
  }
  const oldGlobalParameter = String(body.old_global_parameter || body.oldGlobalParameter || '').trim()
  if (oldGlobalParameter) payload.old_global_parameter = oldGlobalParameter
  return payload
}

export function listGlobalParameters() {
  return remoteRequest('GET', '/getAllGlobalParameters')
}

export function createGlobalParameter(body) {
  return remoteRequest('POST', '/createGlobalParameter', {
    body: normalizeParameter(body),
    headers: { 'Content-Type': 'application/json' },
  })
}

export function updateGlobalParameter(body) {
  return remoteRequest('PUT', '/updateGlobalParameter', {
    body: normalizeParameter(body),
    headers: { 'Content-Type': 'application/json' },
  })
}

export function deleteGlobalParameter(body) {
  const payload = normalizeParameter(body)
  return remoteRequest('DELETE', '/deleteGlobalParameter', {
    query: { global_parameter: payload.global_parameter },
  })
}
